import React from 'react';
import PropTypes from 'prop-types';

import { useTheme } from '@material-ui/core/styles';

import {
  Error as InputFailedIcon,
  SkipNext as InputSkippedIcon, 
  ThumbDown as InputRejectedIcon, 
  Timer as InputPendingIcon,
  Done as InputSucceededIcon,
  DeviceUnknown as UnknownIcon,
} from '@material-ui/icons';

export default function ExecutionInputResultIcon(props) {
  const { value, fontSize, style } = props;
  const theme = useTheme();
  if(value==='FAILED') {
    return(<InputFailedIcon fontSize={fontSize} htmlColor={theme.palette.error.main} style={style}/>);
  } else if(value==='SUCCEEDED') {
    return(<InputSucceededIcon fontSize={fontSize} htmlColor={theme.palette.success.main} style={style} />);
  } else if(value==='SKIPPED') {
    return(<InputSkippedIcon  fontSize={fontSize} htmlColor={theme.palette.warning.main} style={style} />);
  } else if(value==='REJECTED') {
    return(<InputRejectedIcon fontSize={fontSize} style={style}/>);
  } else if(value==='PENDING') {
    return(<InputPendingIcon fontSize={fontSize} htmlColor={theme.palette.info.main} style={style} />);
  } else {
    return(<UnknownIcon fontSize={fontSize} style={style} />);
  }
}


ExecutionInputResultIcon.propTypes = {
  value: PropTypes.oneOf(['FAILED', 'SUCCEEDED', 'SKIPPED', 'REJECTED', 'PENDING']).isRequired,
  fontSize: PropTypes.oneOf(['inherit', 'default', 'small', 'large']),
  style: PropTypes.object,
};

ExecutionInputResultIcon.defaultProps = {
  fontSize: 'small',
};
